var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.937,
    height: 43.937,
    viewBox: "0 0 43.937 43.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: #006533;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    className: "cls-1",
    width: 43.937,
    height: 43.937,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Etapas",
    className: "cls-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-3",
    d: "M18.551,18.545V2.252A2.258,2.258,0,0,1,20.808-.006H41.679a2.258,2.258,0,0,1,2.258,2.258V41.674a2.258,2.258,0,0,1-2.258,2.258H2.258A2.258,2.258,0,0,1,0,41.674V20.8a2.258,2.258,0,0,1,2.258-2.258Zm2.2,23.19H41.679a.061.061,0,0,0,.061-.061V2.252a.061.061,0,0,0-.061-.061H20.808a.061.061,0,0,0-.061.061Zm-2.2-20.993H2.258A.061.061,0,0,0,2.2,20.8V41.674a.061.061,0,0,0,.061.061H18.551Z",
    transform: "translate(0 0.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-3",
    d: "M262.045,310.118a2.258,2.258,0,0,0-2.258-2.258h-4.638a2.258,2.258,0,0,0-2.258,2.258v8.117a1.1,1.1,0,0,0,1.1,1.1h6.957a1.1,1.1,0,0,0,1.1-1.1Zm-2.2,0a.061.061,0,0,0-.061-.061h-4.638a.061.061,0,0,0-.061.061v7.018h4.76Z",
    transform: "translate(-226.224 -275.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-3",
    d: "M314.7,46.237a2.258,2.258,0,0,0-2.258-2.258h-2.319a2.258,2.258,0,0,0-2.258,2.258v2.319a2.258,2.258,0,0,0,2.258,2.258h2.319a2.258,2.258,0,0,0,2.258-2.258Zm-2.2,0a.061.061,0,0,0-.061-.061h-2.319a.061.061,0,0,0-.061.061v2.319a.061.061,0,0,0,.061.061h2.319a.061.061,0,0,0,.061-.061V46.237Z",
    transform: "translate(-275.4 -39.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-3",
    d: "M226.736,46.237a2.258,2.258,0,0,0-2.258-2.258h-2.319a2.258,2.258,0,0,0-2.258,2.258v2.319a2.258,2.258,0,0,0,2.258,2.258h2.319a2.258,2.258,0,0,0,2.258-2.258Zm-2.2,0a.061.061,0,0,0-.061-.061h-2.319a.061.061,0,0,0-.061.061v2.319a.061.061,0,0,0,.061.061h2.319a.061.061,0,0,0,.061-.061V46.237Z",
    transform: "translate(-196.713 -39.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-3",
    d: "M226.736,134.2a2.258,2.258,0,0,0-2.258-2.258h-2.319A2.258,2.258,0,0,0,219.9,134.2v2.319a2.258,2.258,0,0,0,2.258,2.258h2.319a2.258,2.258,0,0,0,2.258-2.258Zm-2.2,0v2.319a.061.061,0,0,1-.061.061h-2.319a.061.061,0,0,1-.061-.061V134.2a.061.061,0,0,1,.061-.061h2.319a.061.061,0,0,1,.061.061Z",
    transform: "translate(-196.713 -118.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-3",
    d: "M314.7,134.2a2.258,2.258,0,0,0-2.258-2.258h-2.319a2.258,2.258,0,0,0-2.258,2.258v2.319a2.258,2.258,0,0,0,2.258,2.258h2.319a2.258,2.258,0,0,0,2.258-2.258Zm-2.2,0v2.319a.061.061,0,0,1-.061.061h-2.319a.061.061,0,0,1-.061-.061V134.2a.061.061,0,0,1,.061-.061h2.319a.061.061,0,0,1,.061.061Z",
    transform: "translate(-275.4 -118.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-3",
    d: "M226.736,222.165a2.258,2.258,0,0,0-2.258-2.258h-2.319a2.258,2.258,0,0,0-2.258,2.258v2.319a2.258,2.258,0,0,0,2.258,2.258h2.319a2.258,2.258,0,0,0,2.258-2.258Zm-2.2,0a.061.061,0,0,0-.061-.061h-2.319a.061.061,0,0,0-.061.061v2.319a.061.061,0,0,0,.061.061h2.319a.061.061,0,0,0,.061-.061Z",
    transform: "translate(-196.713 -196.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-3",
    d: "M314.7,222.162a2.258,2.258,0,0,0-2.258-2.258h-2.319a2.258,2.258,0,0,0-2.258,2.258v2.319a2.258,2.258,0,0,0,2.258,2.258h2.319a2.258,2.258,0,0,0,2.258-2.258Zm-2.2,0v2.319a.061.061,0,0,1-.061.061h-2.319a.061.061,0,0,1-.061-.061v-2.319a.061.061,0,0,1,.061-.061h2.319a.061.061,0,0,1,.061.061Z",
    transform: "translate(-275.4 -196.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-3",
    d: "M55.448,222.162a2.258,2.258,0,0,0-2.258-2.258H46.234a2.258,2.258,0,0,0-2.258,2.258v2.319a2.258,2.258,0,0,0,2.258,2.258h6.957a2.258,2.258,0,0,0,2.258-2.258Zm-2.2,0v2.319a.061.061,0,0,1-.061.061H46.234a.061.061,0,0,1-.061-.061v-2.319a.061.061,0,0,1,.061-.061h6.957a.061.061,0,0,1,.061.061Z",
    transform: "translate(-39.339 -196.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-3",
    d: "M55.449,310.125a2.258,2.258,0,0,0-2.258-2.258H46.234a2.258,2.258,0,0,0-2.258,2.258v2.319a2.258,2.258,0,0,0,2.258,2.258h6.957a2.258,2.258,0,0,0,2.258-2.258Zm-2.2,0v2.319a.061.061,0,0,1-.061.061H46.234a.061.061,0,0,1-.061-.061v-2.319a.061.061,0,0,1,.061-.061h6.957a.061.061,0,0,1,.061.061Z",
    transform: "translate(-39.339 -275.403)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProyecto);
export default __webpack_public_path__ + "static/media/Proyecto.82f2b18a06b9aa79c873021dfb1e55ab.svg";
export { ForwardRef as ReactComponent };